var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewChat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "compose",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.49,
    height: 21.503,
    viewBox: "0 0 21.49 21.503",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "compose-2",
    "data-name": "compose",
    d: "M21.94,2.76l-.71-.71a2.758,2.758,0,0,0-3.89,0L7.03,12.38a1.767,1.767,0,0,0-.51,1.08l-.27,2.93a1.285,1.285,0,0,0,.36,1,1.234,1.234,0,0,0,.88.37H7.6l2.93-.27a1.767,1.767,0,0,0,1.08-.51L21.93,6.66a2.728,2.728,0,0,0,0-3.88ZM10.56,15.91a.418.418,0,0,1-.15.07l-2.63.24.24-2.63a.257.257,0,0,1,.07-.16l8.38-8.38,2.47,2.47L10.56,15.9ZM20.88,5.59,20,6.47,17.53,4l.88-.88a1.251,1.251,0,0,1,.88-.37,1.21,1.21,0,0,1,.88.37l.71.71a1.234,1.234,0,0,1,.37.88,1.217,1.217,0,0,1-.37.88Zm-.13,7.6V19A3.751,3.751,0,0,1,17,22.75H5A3.751,3.751,0,0,1,1.25,19V7A3.751,3.751,0,0,1,5,3.25h5.81a.75.75,0,0,1,0,1.5H5A2.253,2.253,0,0,0,2.75,7V19A2.253,2.253,0,0,0,5,21.25H17A2.253,2.253,0,0,0,19.25,19V13.19a.75.75,0,0,1,1.5,0Z",
    transform: "translate(-1.25 -1.247)",
    fill: "#24439c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewChat);
export default __webpack_public_path__ + "static/media/new-chat.d09acb7a48ec846d0d4fdf71443b3c7c.svg";
export { ForwardRef as ReactComponent };